// extracted by mini-css-extract-plugin
export var header = "_aq-0";